module.exports = __webpack_public_path__ + "img/P44920580Tcamera.595ec428.jpg";